(function () {
    let PhotoDocumentsController = (function () {
        function PhotoDocumentsController($scope, $q, mdPanelRef, cameraService, dialogData) {
            $scope.vm = this;
            this.$scope = $scope;
            this.$q = $q;
            this.mdPanelRef = mdPanelRef;
            this.cameraService = cameraService;

            this.onClose = dialogData.onClose;
            this.onStart = dialogData.onStart;
            this.acceptOnlyPicture = dialogData.acceptOnlyPicture;

            // default to show items
            this.isShowPhotoLibrary = true;
            this.isShowTakePhoto = true; // always show camera
            this.isShowChooseFiles = !this.acceptOnlyPicture;
        }

        PhotoDocumentsController.prototype = {
            close(data) {
                this.onClose(data);
            },

            /**
             * Get an image from Photo Gallery
             */
            showPhotoLibrary() {
                this.mdPanelRef.close();
                if (this.onStart) {
                    this.onStart();
                }
                if (ionic.Platform.isIOS()) { // use default  camera to take photo on iOS
                    this.getPictureIOS(window['Camera'].PictureSourceType.PHOTOLIBRARY);
                } else {
                    this.showPhotoLibraryAndroid();
                }
            },

            
            /**
             * Take photo by using Camera
             */
            showTakePhoto() {
                this.mdPanelRef.close();
                if (this.onStart) {
                    this.onStart();
                }
                this.cameraService.checkCameraPermission().then(() => {
                    if (ionic.Platform.isIOS()) { // use default  camera to take photo on iOS
                        this.getPictureIOS(window['Camera'].PictureSourceType.CAMERA);
                    } else { // use preview-camera to take photo on Android
                        this.cameraService.showCameraPreviewModal().then(this.cameraSuccess.bind(this), this.cameraError.bind(this));
                    }
                }, ()=>{
                    this.checkPermissionError("Don't have permission to access Camera");
                });
            },

            /**
             * Choose files
             */
            showChooseFiles() {
                this.mdPanelRef.close();
                if (this.onStart) {
                    this.onStart();
                }
                // NF-907: Don't need check Permission when choose a file
                window['chooser'].getFile().then((file) => {
                    if (file) {
                        let imgBlob = new Blob([file.data], {type: file.type});
                        imgBlob['name'] = file.name;
                        this.cameraSuccess(imgBlob);
                    } else {
                        this.cameraSuccess();
                    }
                }, this.chooseFilesError.bind(this));
            },
            /**
             * Get file when Success
             * @private
             */
            cameraSuccess(file) {
                this.close(file);
            },
            cameraError(error) {
                console.log('cameraError: ', error)
                this.close();
            },
            checkPermissionError(error){
                console.log(error);
                this.close();
            },
            chooseFilesSuccess(file){
                this.close(file)
            },
            chooseFilesError(error){
                console.log('chooseFilesError: ', error);
                this.close();
            },
            /**
             * Take Picture, Get Files from  cordova-plugin-camera
             * @param sourceType{number}
             */
            getPictureIOS(sourceType) {
                let options = {
                    quality: 80, // quality output of image
                    sourceType: sourceType,
                    encodingType: window['Camera'].EncodingType.JPEG,
                    destinationType: window['Camera'].DestinationType.FILE_URI,
                    mediaType: window['Camera'].MediaType.PICTURE,
                    correctOrientation: true,
                    saveToPhotoAlbum: false
                };
                navigator['camera'].getPicture((uri) => {
                    this.convertUriToBlob(uri).then(this.cameraSuccess.bind(this), this.cameraError.bind(this));
                }, (error) => {
                    this.cameraError(error);
                }, options)
            },

            /**
             * Convert url to Blob
             * @param uri{string}
             * @param fileName{string}
             * @returns {Promise<Blob>}
             */
            convertUriToBlob(uri, fileName) {
                return this.$q((resolve, reject) => {
                    this.convertFileUriToFileEntry(uri).then((fileEntry) => { // Convert local url to FileEntry
                        this.convertFileEntryToFile(fileEntry).then((file) => { // Convert FileEntry to File
                            this.convertFileToBlob(file, fileName).then((blob) => { // Convert File to Blob
                                resolve(blob);
                            }, reject);
                        }, reject)
                    }, reject);
                });
            },

            /**
             * Convert ImageUri to FileEntry
             * @param imageUri{string}
             * @returns {Promise<FileEntry>}
             */
            convertFileUriToFileEntry(imageUri) {
                return this.$q((resolve, reject) => {
                    // file choose from gallery return absolute path, need mananual add prefix file:///
                    // re-consider this point for IOS
                    // files choose from folder download of device have refix content://
                    imageUri = imageUri.indexOf('cdvfile://') > -1 || imageUri.indexOf('file://') > -1 || imageUri.indexOf('content://') > -1 ? imageUri : 'file://' + imageUri;
                    window['resolveLocalFileSystemURL'](imageUri, resolve, reject);
                })
            },

            /**
             * Convert FileEntry to File
             * @param fileEntry{FileEntry}
             * @returns {Promise<File>}
             */
            convertFileEntryToFile(fileEntry) {
                return this.$q((resolve, reject) => {
                    fileEntry.file(resolve, reject);
                });
            },


            
            /**
             * Convert File to Blob
             * @param file{File}
             * @param fileName{String}
             * @returns {Promise<Blob>}
             * @private
             */
            convertFileToBlob(file, fileName) {
                return this.$q((resolve, reject) => {
                    const fileReader = new FileReader();
                    fileReader.readAsArrayBuffer(file);
                    fileReader.onloadend = () => {
                        let imgBlob = new Blob([fileReader.result], {type: file.type});
                        imgBlob['name'] = fileName ? fileName: this.getFileName(file);
                        resolve(imgBlob);
                    };
                    fileReader.onerror = (error) => {
                        reject(error);
                    };
                });
            },

            /**
             * Opens the photo library on Android devices and allows the user to choose an image.
             *
             * @return {void}
             * @private
             */
            showPhotoLibraryAndroid() {
                window['ImagePicker'].pickImage((result) => {
                    if (result) {
                        this.convertUriToBlob(result.uri, result.name).then(this.chooseFilesSuccess.bind(this), this.chooseFilesError.bind(this));
                    } else {
                        this.chooseFilesSuccess(null);
                    }
                }, (error) => {
                    this.chooseFilesError(error);
                });
            },
            /**
             * Get file name from File
             * @param file{File}
             */
            getFileName(file) {
                if (file.name.lastIndexOf(".") !== -1) {
                    return file.name;
                } else {
                    let extension = file.type.split("/")[1];
                    return file.name + "." + extension;
                }
            }

        }
        PhotoDocumentsController.$inject = [
            '$scope',
            '$q',
            'mdPanelRef',
            'CameraService',
            'dialogData'
        ];
        return PhotoDocumentsController;
    }());
    angular.module('shared.camera.PhotoDocumentsController', []).controller('PhotoDocumentsController', PhotoDocumentsController);
})();